export function isLockedFinancePeriodError(error: unknown): boolean {
  const message = String((error as any)?.message || '');
  return message.includes('LOCKED_FINANCE_PERIOD');
}

export function getFriendlyFinanceErrorMessage(error: unknown, fallback: string): string {
  if (isLockedFinancePeriodError(error)) {
    return 'Periodo financeiro travado. Reabra o periodo em Fechamento para editar.';
  }
  const message = String((error as any)?.message || '').trim();
  return message ? `${fallback}: ${message}` : fallback;
}
